import { useIsFirstRender } from './useFirstRender';

export const useOnBeforeFirstRender = (cb: () => any) => {
  if (useIsFirstRender()) {
    cb();
  }
};
